import { WaitlistButton } from "@/components/landing/WaitlistButton";

export const CTABanner = () => {
  return (
    <section
      data-testid="cta-banner-section"
      className="bg-[#F0F4EE] px-4 sm:px-6 lg:px-12 pt-10 pb-20 md:pb-28"
    >
      <div className="mx-auto max-w-6xl relative overflow-hidden rounded-[2rem] bg-[#4A6B41] text-[#F9F6F0] p-10 md:p-16 text-center shadow-xl">
        <div
          aria-hidden
          className="absolute -top-16 -right-10 h-56 w-56 rounded-full bg-[#F9F6F0]/10 blur-2xl"
        />
        <div
          aria-hidden
          className="absolute -bottom-20 -left-10 h-56 w-56 rounded-full bg-[#C86D51]/20 blur-2xl"
        />
        <div className="relative">
          <span className="font-sans text-xs sm:text-sm uppercase tracking-[0.25em] font-bold text-[#F9F6F0]/80">
            Where Fresh Starts
          </span>
          <h2 className="mt-4 font-sans font-extrabold text-3xl sm:text-4xl lg:text-5xl tracking-tight">
            Be first in line when we launch
          </h2>
          <p className="mt-5 mx-auto max-w-xl font-sans text-base sm:text-lg text-[#F9F6F0]/85 leading-relaxed">
            Join the waitlist to get early access and help shape a
            fresher, fairer local food system.
          </p>
          <div className="mt-8 flex justify-center">
            <WaitlistButton testid="cta-banner-join-waitlist-btn" variant="light" />
          </div>
        </div>
      </div>
    </section>
  );
};
